import { render } from "./SelecionarPlanoAssinatura.vue?vue&type=template&id=584e68bf&ts=true"
import script from "./SelecionarPlanoAssinatura.vue?vue&type=script&lang=ts"
export * from "./SelecionarPlanoAssinatura.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__